import {useTranslation} from "react-i18next";
import Logo from '../../Assets/images/logo/connectcaremintgreen.png';
import {Link, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import {PrimaryButton} from "../../Components/Buttons/PrimaryButton";
import {TextInput} from "../../Components/Form/TextInput";
import {useBoundStore} from "../../Store/store";
import {useEffect, useState} from "react";

export const RejectShiftChangeRequest = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const rejectShiftChangeRequest = useBoundStore(state => state.rejectShiftChangeRequest);
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams();
    const [error, setError] = useState(false);

    const user = useBoundStore(state => state.user);

    useEffect(() => {
        if (!user) {
            toast.error(t('auth.not_logged_in'));
            navigate('/login');
            return;
        }

        setError(false);
        const s = searchParams.get('s');
        if (!s) {
            navigate('/');
            return;
        }
        rejectShiftChangeRequest(params?.id, s).then(() => {}).catch(error => {
            toast.error(t('auth.invalid_link'));
            setError(true);
        },[rejectShiftChangeRequest]);
    });

    return (
        <div className={'flex flex-col justify-center h-screen w-full'}>
            <div className={'p-3 text-center'}>
                <img src={Logo} alt={'Logo for connect care mint green'} className={'max-h-16 mx-auto'}/>
            </div>
            <div className={'p-3 w-full max-w-[80%] md:max-w-[50%] mx-auto'}>
                {
                    error && (
                        <>
                            <p>{t('shift_change.invalid_link')}</p>

                            <div className={'flex flex-row justify-center mt-4'}>
                                <PrimaryButton
                                    onClick={() => {
                                        navigate('/');
                                    }}
                                >
                                    {t('shift_change.back_to_homepage')}
                                </PrimaryButton>
                            </div>
                        </>
                    )
                }

                {
                    !error && (
                        <>
                            <p>
                                {t('shift_change.reject_success')}
                            </p>

                            <div className={'flex flex-row justify-center mt-4'}>
                                <PrimaryButton
                                    onClick={() => {
                                        navigate('/');
                                    }}
                                >
                                    {t('login.cta_dashboard')}
                                </PrimaryButton>
                            </div>
                        </>
                    )
                }
            </div>
        </div>
    )
}